import { cn } from "../../lib/utils.js";

/** Geometry from `feedbot-icon-original.svg`. Shared so every mark renders the same artwork. */
export const FEEDBOT_MARK_VIEWBOX = "0 0 512 512";

export const FEEDBOT_MARK_BUBBLE_PATH = `M36.4,436.5l-36,3.2l15.3-32.8l19.9-42.7C19.9,331.4,11.1,294.7,11.1,256C11.1,117.7,123.2,5.6,261.6,5.6
	S512,117.7,512,256S399.9,506.4,261.6,506.4c-69.5,0-132.4-28.3-177.8-74.1L36.4,436.5z M70.2,364L64,377.4l-12.3,26.4l29.3-2.6
	l14.6-1.3l10.3,10.4c39.7,40.1,94.7,64.8,155.6,64.8c121,0,219.1-98.1,219.1-219.1S382.6,36.9,261.6,36.9S42.4,135,42.4,256
	c0,33.9,7.7,66,21.4,94.6L70.2,364z`;

export const FEEDBOT_MARK_F_POINTS =
  "165.9,157.6 296,157.6 296,180.8 192.4,180.8 192.4,228.7 230.7,228.7 230.7,251.8 192.4,251.8 192.4,316.5 165.9,316.5";

export const FEEDBOT_MARK_B_PATH = `M325.8,329c7.4,0,13.2-1.7,17.2-5c4.2-3.3,6.4-7.9,6.4-13.8v-10.2c0-5.1-1.8-9.2-5.4-12.3
	c-3.6-3.2-8.5-4.8-14.5-4.8h-58.8V329H325.8z M320.6,261.1c5.6,0,10.1-1.8,13.6-5.4c3.5-3.6,5.2-8.3,5.2-14.1v-9.3
	c0-4.8-2-8.7-5.9-11.6c-3.8-2.9-8.9-4.3-15.2-4.3h-47.7v44.7H320.6z M263.6,352.2c-5.7,0-10.4-1.7-14.1-5.2
	c-3.6-3.6-5.4-8.2-5.4-13.8V193.3h75.1c14.1,0,25.3,3.4,33.8,10.2c8.6,6.7,12.9,15.5,12.9,26.6v11.6c0,5.3-1.3,10.3-3.9,15
	c-2.6,4.7-6.1,8.5-10.7,11.3v0.2c7.4,2.4,13.3,6.5,17.7,12.3c4.5,5.7,6.8,12.3,6.8,19.5v11.3c0,12.6-4.3,22.5-12.9,30
	c-8.6,7.3-20.3,10.9-35,10.9H263.6z`;

interface FeedBotMarkProps {
  className?: string;
  /** Accessible name. Omit when nearby text already names the product. */
  label?: string;
}

/**
 * Compact FB-in-bubble mark. Static; chevrons belong on the wordmark only.
 */
export function FeedBotMark({ className, label }: FeedBotMarkProps): React.JSX.Element {
  return (
    <svg
      viewBox={FEEDBOT_MARK_VIEWBOX}
      role={label ? "img" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
      className={cn("fill-brand", className)}
    >
      <path fillRule="evenodd" d={FEEDBOT_MARK_BUBBLE_PATH} />
      <polygon points={FEEDBOT_MARK_F_POINTS} />
      <path d={FEEDBOT_MARK_B_PATH} />
    </svg>
  );
}
